const Null = {}

export default Null;
